import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Chip from '@features/filter/Chip';

import { clearSelectedFilterName, toggleBlockSuggestionsFilter } from '@store/actions/FilterAction';
import { useBlockProductList } from '@store/reducers';

const BlockSuggestionsFilter = () => {
	const dispatch = useDispatch();
	const blocks = useBlockProductList();
	const [filterActive, setFilterActive] = useState(false);

	const handleFilterToggle = () => {
		const updatedFilterState = !filterActive;
		setFilterActive(updatedFilterState);
		dispatch(toggleBlockSuggestionsFilter(updatedFilterState));
		dispatch(clearSelectedFilterName());
	};

	return (
		<div className="filter-container-top on-sample-details">
			<div className="filters">
				<div className="filter-toggle" onClick={handleFilterToggle}>
					<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
					<span>Filter </span>
					<span className="ml-1 regular-12">
						{blocks?.totalElements && `${blocks?.totalElements} Items`}
					</span>
				</div>
				<Chip />
			</div>
		</div>
	);
};

export default BlockSuggestionsFilter;
